<template>
  <div class="order-list">
    <div class="tabs">
      <span :class="{active: activeTab === 1}" @click="setActiveTab(1)">全部</span>
      <span :class="{active: activeTab === 2}" @click="setActiveTab(2)">待支付</span>
      <span :class="{active: activeTab === 3}" @click="setActiveTab(3)">待发货</span>
      <span :class="{active: activeTab === 4}" @click="setActiveTab(4)">待收货</span>
    </div>

    <div v-for="order in orders" :key="order.id" class="order">
      <div class="order-item">
        <img :src="order.product_type_sku_img_url" class="order-image" />
        <div class="order-details">
          <p class="order-title">{{ order.product_name }}</p>
          <p class="order-size">{{ order.product_type_name }}</p>
          <p class="order-price">￥{{ order.order_price }}</p>
          <p class="order-number">数量: X{{ order.order_num }}</p>
          <p class="order-status">实付 ￥{{ order.order_total }}</p>

          <p style="color: red;">{{refund_status[order.refund_status]}}</p>
        </div>
      </div>
      <div class="order_btn">

        <button class="action-button" @click="orderInfoView(order)">订单详情</button>
        <button v-if="order.pay_status==0" class="action-button" @click="orderInfoView(order,'pay')">立即支付</button>
        <!-- <button v-if="order.pay_status==0" class="action-button" @click="orderInfoView(order)">取消订单</button> -->
        <button v-if="order.pay_status==1 && order.refund_status==0" class="action-button" @click="orderInfoView(order,'after')">申请退款</button>
      </div>
    </div>
    <div class="zanwu" v-if="!orders">
      <img src="../assets/zanwu.png">
      <div>暂无数据</div>
    </div>
  </div>
</template>

<script>
  import {orderList} from "../utils/api"
export default {
  data() {
    return {
      activeTab: 1,
      type:1,
      orders: [],
      refund_status:{
        '-1':'退款申请中',
        0:'',
        1:'已退款',
        2:'退款失败'
      }
    };
  },
  created(){
    this.type = this.$route.query.id?this.$route.query.id:1
    this.activeTab = this.$route.query.id?this.$route.query.id:1
    this.getList()
  },
  computed: {
    filteredOrders() {
      if (this.activeTab === 'all') {
        return this.orders;
      }
      return this.orders.filter(order => order.status === this.activeTab);
    }
  },
  methods: {
    getList(){
      orderList({type:this.type}).then(res=>{
        console.log(res,"wwwww")
        this.orders = res.data;
      })
    },
    orderInfoView(order){
      this.$router.push({
        name:'orderInfo',
        query:order
      })
    },
    setActiveTab(tab) {
      this.activeTab = tab;
      this.type = tab;
      this.getList()
    }
  }
};
</script>

<style scoped>
.order-list {
  padding: 20px;
}

.tabs {
  display: flex;
  justify-content: space-around;
  margin-bottom: 10px;
}

.tabs span {
  cursor: pointer;
}

.tabs .active {
  color: red;
}
.order{
  border-bottom: 1px solid #ddd;
  padding: 10px 0;
}

.order-item {
  display: flex;
  align-items: center;

}

.order-image {
  width: 100px;
  height: 100px;
  margin-right: 20px;
}
.order_btn{
  display: flex;
  justify-content: flex-end;
}
.order-details {
  flex: 1;
}

.order-title {
  font-size: 16px;
  font-weight: bold;
}

.order-size,
.order-price,
.order-number,
.order-status {
  font-size: 14px;
  color: #666;
}

.action-button {
  color: #ff0000;
  background-color: #fff;
  border: 1px solid #ff0000;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
  margin-right:10px;
}
.zanwu{
  margin-top: 100px;
  text-align: center;
}
.zanwu img{
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/myorder.vue